import { createStore, combineReducers, applyMiddleware } from 'redux';
import { persistStore, persistReducer } from 'redux-persist';
import { composeWithDevTools } from 'redux-devtools-extension';
import createSagaMiddleware from 'redux-saga';
import rootReducer from './redux';
import storageSession from 'redux-persist/lib/storage/session';
import { seamlessImmutableReconciler, seamlessImmutableTransformCreator } from 'redux-persist-seamless-immutable';
import Global from './lib/Global';

var initialState = {};
const sagaMiddleWare = createSagaMiddleware();
const transformerConfig = {
  whitelistPerReducer: {
    // auth: ['token', 'isAuthenticated', 'customerId', 'distributorId'],
    ajax: ['isAjaxIncludedInMonitoring'],
  },
};
const store = createStore(
  persistReducer(
    {
      transforms: [seamlessImmutableTransformCreator(transformerConfig)],
      stateReconciler: seamlessImmutableReconciler,
      key: 'auth',
      debug: true,
      storage: storageSession,
      whitelist: ['auth', 'customers', 'ajax'],
    },
    rootReducer
  ),
  initialState,
  composeWithDevTools(applyMiddleware(sagaMiddleWare))
);

const persistor = persistStore(store, null, () => {
  console.log('restoredState', store.getState());
  if (store.getState().auth.token != null) {
    //Set global api access token for Bearer
    Global.api = {
      ...Global.api,
      accessToken: store.getState().auth.token,
    };
  }
});

export default { store, persistor, sagaMiddleWare };
